import { filterObjectValues } from 'helpers/filter'

import { Mqr } from 'models/mqr'
import { IStatistic } from 'models/statistic'

import { downloadFileHandler } from 'shared/libs'

import api, { CreateMqrTagType } from '../api'
import { GetMqrParams, GetMqrResponse } from './types'

export const mqrApi = api.injectEndpoints({
  endpoints: build => ({
    getMqrs: build.query<GetMqrResponse, GetMqrParams>({
      query: params => ({
        url: `/web/mqr/`,
        params: filterObjectValues(params),
        cache: 'no-store',
      }),
      providesTags: [CreateMqrTagType],
    }),
    getMqrById: build.query<Mqr, Mqr['id']>({
      query: id => ({
        url: `/web/mqr/${id}/`,
      }),
      providesTags: [CreateMqrTagType],
    }),
    mqrStatistics: build.query<Array<IStatistic>, GetMqrParams>({
      query: params => ({
        url: `/web/mqr/statistics/`,
        params: filterObjectValues(params),
      }),
      keepUnusedDataFor: 60,
    }),
    downloadMqrExcel: build.mutation<void, GetMqrParams>({
      query: params => ({
        url: `/web/mqr/excel/`,
        params: filterObjectValues(params),
        responseHandler: downloadFileHandler,
        cache: 'no-cache',
      }),
    }),
  }),
})
